import { observer } from "mobx-react-lite";

import { ISchemaParameter } from "../schema-parameter-store";

import { ArrayParameterContent } from "./ArrayParameterContent";
import { NumberParameterContent } from "./NumberParameterContent";
import { StringParameterContent } from "./StringParameterContent";

interface Props {
  parameter: ISchemaParameter;
}
const JSONSchemaParameterContent = observer(({ parameter }: Props) => {
  switch (parameter.type) {
    case "string":
      return <StringParameterContent parameter={parameter} />;
    case "number":
      return <NumberParameterContent parameter={parameter} />;
    case "integer":
      return <NumberParameterContent parameter={parameter} />;
    case "array":
      return <ArrayParameterContent parameter={parameter} />;
    default:
      return null;
  }
});

export { JSONSchemaParameterContent };
